import { Block, Flex, RadioGroup } from '@aloft/toolkit-sui';

const MAP_VIEW_ITEMS = [
  { value: 'satellite', label: 'Satellite' },
  { value: 'street', label: 'Street' },
];

const MAP_OVERLAY_SHADOW = '0px 0px 2px 0px rgba(0,0,0,0.04), 0px 8px 8px 0px rgba(0,0,0,0.08)';

export const MAP_VIEWS_OVERLAY_BOTTOM_OFFSET_PX = 72;

type MapViewsOverlayProps = {
  mapType: string;
  onChange: (value: string) => void;
};

export const MapViewsOverlay = ({ mapType, onChange }: MapViewsOverlayProps) => (
  <Flex position="absolute" bottom="12px" right="12px" zIndex="1">
    <Block
      backgroundColor="surface1"
      padding="4px 8px"
      borderRadius="8px"
      boxShadow={MAP_OVERLAY_SHADOW}
    >
      <RadioGroup
        value={mapType}
        items={MAP_VIEW_ITEMS}
        size="sm"
        textVariant="h4"
        gap="0"
        onChange={onChange}
      />
    </Block>
  </Flex>
);
